import React from 'react';
import StyledCategorySection from './StyledCategorySection';
import {
  SideNavCategory,
  SideNavCategoryTypeName,
  SideNavColorSchemeProps,
  SideNavItemSelectEvent,
} from '../index';
import StyledCategorySectionHeader from './StyledCategorySectionHeader';
import StyledCategoryItem from './StyledCategoryItem';
import { noop } from '../../../util';
import { replaceIfrsLabels } from '../../../util/frs102Helper';
import { useIsFrs102Enabled } from '../../../util/hooks/useIsFrs102Enabled';

interface CategoriesSectionProps extends SideNavColorSchemeProps {
  category: SideNavCategory;
  isSearching: boolean;
  onItemSelect?: (e: SideNavItemSelectEvent) => void;
  selectedItem?: SideNavCategory;
}

function CategorySection({
  category: { name, items },
  isSearching,
  colorScheme,
  onItemSelect,
  selectedItem,
}: CategoriesSectionProps): JSX.Element {
  const isFrs102Enabled = useIsFrs102Enabled();

  const categoryItemComponents = items.map((item) => {
    const isActive =
      selectedItem && item.key === selectedItem.key && !isSearching;
    const itemClickHandler = (e: React.MouseEvent): void => {
      if (!isActive) {
        onItemSelect({
          ...e,
          category: item,
        });
      }
    };

    // Hide Searchable category - its only used for searching
    if (item.key === SideNavCategoryTypeName.Searchable) {
      return;
    }
    return (
      <StyledCategoryItem
        colorScheme={colorScheme}
        key={item.key}
        isActive={isActive}
        onClick={itemClickHandler}
      >
        {replaceIfrsLabels(item.name, isFrs102Enabled)}
      </StyledCategoryItem>
    );
  });

  return (
    <StyledCategorySection>
      <StyledCategorySectionHeader variant="h3">
        {name}
      </StyledCategorySectionHeader>
      {categoryItemComponents}
    </StyledCategorySection>
  );
}

CategorySection.defaultProps = {
  onItemSelect: noop,
};

export default CategorySection;
